import styled from "@emotion/styled";
import { Container } from "@mui/material";
import React from "react";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding-bottom: 35px; */
`;
const FirstCell = styled.div`
background-color: rgba(13, 119, 87, 0.15);
  font-family: "poppins-SemiBold";
`;
const NextCell = styled.div`
  font-family: "poppins-SemiBold";
  /* padding-bottom: 20px; */
  text-align: center;
`;
const SecondCell = styled.div``;

const Socials = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 366px) {
    /* display: block; */
  }
`;
const Sociallinks = styled.a`
  text-decoration: none;
  cursor: pointer;
  margin-left: 10px;

  display: flex;
  align-items: center;
`;
const SocialText = styled.span`
  color: #243d44;
  padding-left: 10px;
  font-weight: 600;
  @media screen and (max-width: 900px) {
    color: #fff;
  }
`;
const Text = styled.span`
  color: #243d44 !important;
  font-weight: 600;
  @media screen and (max-width: 599px) {
    text-transform: lowercase;
    display: none;
  }
`;

const Cells = styled.div`
  @media screen and (max-width: 599px) {
    display: none;
  }
`;
const Cells1 = styled.div`
  display: none;
  @media screen and (max-width: 599px) {
    display: flex;

    padding-bottom: 10px;
    place-content: center;
  }
`;
const TwitterImage = styled.img`
width: 100%;
height: auto;
max-width: 30px;
`;
const TelegramImage = styled.img`
width: 100%;
height: auto;
max-width: 30px;
`;
const MediumImage = styled.img`
width: 100%;
height: auto;
max-width: 30px;
`;

const index = () => {
  return (
    <div>
      <Container maxWidth="xl">
        <Wrapper>
          <Cells>
            <FirstCell>Copyright © 2022 kirintoken</FirstCell>
          </Cells>

          <SecondCell>
            <Socials>
              <Text>Follow us:</Text>
              <Sociallinks
                href="https://twitter.com/Kirintokeneth"
                target="blank"
              >
                <TwitterImage
                  src="/images/twitter.png"
                  width="30"
                  height="30"
                  layout="intrinsic"
                />

                {/* <SocialText>Twitter</SocialText> */}
              </Sociallinks>
              <Sociallinks href="https://t.me/kirineth" target="blank">
                <TelegramImage
                  src="/images/telegram.png"
                  width="30"
                  height="30"
                  layout="intrinsic"
                />
                {/* <SocialText>Telegram</SocialText> */}
              </Sociallinks>
              <Sociallinks
                href="https://medium.com/@adley352/kirin-saviour-of-degens-ea026d04f8fb"
                target="blank"
              >
                <MediumImage
                  src="/images/medium.png"
                  width="30"
                  height="30"
                  layout="intrinsic"
                />
                {/* <SocialText>Medium</SocialText> */}
              </Sociallinks>
            </Socials>
          </SecondCell>
        </Wrapper>
        <Cells1>
          <NextCell>Copyright © 2022 kirintoken</NextCell>
        </Cells1>
      </Container>
    </div>
  );
};

export default index;
